export const SET_EMAILTEMPLATES = "SET_EMAILTEMPLATES";
export const SET_SENDEELISTS = "SET_SENDEELISTS";
//export const SET_ADDSENDEE = "SET_ADDSENDEE";
//export const SET_DELETESENDEE = "SET_DELETESENDEE";
//export const SET_ADDEMAILTAG = "SET_ADDEMAILTAG";
//export const SET_DELETEEMAILTAG = "SET_DELETEEMAILTAG";
export const SET_SAVEEMAILTEMPLATE = "SET_SAVEEMAILTEMPLATE";
export const SET_PREVIEWDATA = "SET_PREVIEWDATA";

